module.exports = __webpack_public_path__ + "images/psp/PSPHero/commercial-hero.webp";